// gatsby-browser.js
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import React from 'react'
import { LocationProvider } from './src/contexts/LocationContext'

const LANGUAGE_STORAGE_KEY = 'gatsby-i18next-language'

const getLanguageFromPath = () => {
  if (typeof window === 'undefined') return 'en'
  const match = window.location.pathname.match(/^\/(fr|de)(?=\/|$)/)
  return match?.[1] || 'en'
}

export const wrapRootElement = ({ element }) => (
  <LocationProvider>
    {element}
  </LocationProvider>
)

export const onClientEntry = () => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, getLanguageFromPath())
  } catch {}
}

export const onInitialClientRender = () => {
  // Restore PostHog consent from previous session
  try {
    const stored = localStorage.getItem('rentaflixCookieConsent')
    if (stored) {
      const consent = JSON.parse(stored)
      if (consent.analytics) window.posthog?.opt_in_capturing()
    }
  } catch {}
}
